import React, { useState, useEffect } from 'react';
import {
  Container, 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Button, 
  Grid, 
  Typography, 
  Stepper, 
  Step, 
  StepLabel, 
  Box, 
  CircularProgress, 
  TableCell, 
  TableHead, 
  TableRow, 
  Table, 
  TableBody, 
  Chip, 
  FormControlLabel, 
  Checkbox, 
  Card, 
  InputAdornment,
  Link,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles, withStyles  } from '@material-ui/core/styles';
import axios from 'src/utils/axios';
import PersonIcon from '@material-ui/icons/Person'; // Person icon
import LocalMallIcon from '@material-ui/icons/LocalMall'; // Ürün icon
import { getUser, moneyFormat } from 'src/utils/Common';
import { base64Reader, saveFotograf } from 'src/utils/storage/StrPhoto';
import { useHistory } from 'react-router';

const Compress = require('compress.js');
const compress = new Compress();

const useStyles = makeStyles((theme) => ({
  stepper: {
    backgroundColor: 'transparent',
  },
  step: {
    '&$completed': {
      color: theme.palette.success.main,
    },
    '& .MuiStepLabel-label': {
      color: 'grey', // Tamamlanmamış adımlar için gri renk
    },
  },
  completed: {
    '& .MuiStepLabel-label': {
      color: theme.palette.success.main, // Tamamlanmış adımlar için yeşil renk
    },
  },
  activeStep: {
    '& .MuiStepLabel-label': {
      color: theme.palette.primary.main, // Aktif adım için birincil renk
    },
  },
  box: {
    width: '900px',
    border: '1px solid grey',
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.paper,
  },
  line: {
    borderBottom: '2px solid grey',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  materialRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: '1px solid grey', // Alt çizgi ekliyoruz
    cursor: 'pointer', // İşaretçi ikonunu değiştir
    '&:hover': {
      backgroundColor: '#f0f0f0', // Hover durumunda arka planı değiştir
    },
    '&.selected': {
      backgroundColor: '#d3d3d3', // Seçildiğinde arka planı gri yap
    },
  },
  selectedMaterialDetails: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid grey',
    borderRadius: theme.spacing(1),
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: '#4caf50',
    '&$checked': {
      color: '#4caf50',
    },
  },
  checked: {},
})(Checkbox);

const Purchase = ({ WorkCaseId, handleCloseDialog, consumerId }) => {
  const { t } = useTranslation('overview');
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [materials, setMaterials] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [paymentType, setPaymentType] = useState(0);
  const [PaymentDetail, setPaymentDetail] = useState('');
  const [formData, setFormData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const SessionUser = getUser();
  const [activePaymentTypeData, setActivePaymentTypeData] = useState([]);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const history = useHistory();
  const [attachements, setAttachements] = useState({
    name: "",
    file: {},
    MIMEType: "",
    FileData: ""
  });

  const steps = ['Customer and Product Details', 'Available Materials', 'Payment Method', 'Order and Payment Confirmation'];

  useEffect(() => {
    fetchGetValuePropositionHeaderByWorkCaseId(WorkCaseId);
    fetchGetConsumerValuePropositionDetailByWorkCaseId(WorkCaseId);
  }, [WorkCaseId]);

  useEffect(() => {
    GetActivePaymentTypes();
  }, []);

  const fetchGetValuePropositionHeaderByWorkCaseId = async (id) => {
    axios
      .get(`/GetValuePropositionHeader/${id}`)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setFormData(response.data[0]);
        }
      });
  };

  const fetchGetConsumerValuePropositionDetailByWorkCaseId = async (id) => {
    axios
      .get(`/GetConsumerValuePropositionDetail/${id}`)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
          setMaterials(response.data);
        }
      });
  };

  const handleChangeImage = async (event) => {
    var files = event.target.files[0];
    let base64Result = '';
    if (!window.navigator.onLine) {
      // offline
      let reader = new FileReader();
      reader.onload = function (base64) {
        saveFotograf(
          // ReceiptNo,
          base64.target.result,
          // DosyaTipi,
          files.name,
          files.type
        );
      };
      reader.readAsDataURL(files);
    } else {
      const meta = files?.type;
      if (meta.indexOf('image') !== -1) {
        const resizedImage = await compress.compress([files], {
          size: 0.3, // the max size in MB, defaults to 2MB
          quality: 1, // the quality of the image, max is 1,
          maxWidth: 1920, // the max width of the output image, defaults to 1920px
          maxHeight: 1920, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        });
        const img = resizedImage[0];
        base64Result = img.data;
      } else {
        base64Result = await base64Reader(files);
      }
    }
    event.persist();
    setAttachements({
      name: files?.name,
      MIMEType: files?.type,
      file: files,
      FileData: base64Result
    });
  };

  const setWorkCaseAndContract = async () => {
    const dataBody = {
      WorkCaseId: WorkCaseId || 0,
      ConsumerId: consumerId || 0,
      SKU: formData?.ProductCode,
      SerialNr: formData?.SerialNr,
      ProductionYear: formData?.ProductionYear,
      ProductionMonth: formData?.ProductionMonth,
      PaymentTypeId: paymentType,
      PaymentDetail: PaymentDetail,
      MaterialId: selectedMaterial.MaterialId,
      EmployeeId: SessionUser.TechnicianId,
      FileName: attachements?.name,
      MIMEType: attachements?.MIMEType,
      FileData: attachements?.FileData,
    };
    const dataConfigCancellation = {
      headers: { 'Content-Type': 'application/json' }
    };

    try {
      const response = await axios.post(`/SetWorkCaseAndContractForValueProposition`, dataBody, dataConfigCancellation);
      if (response.data !== "") {
        setFormData(response.data[0]);
        return response.data;
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleMaterialSelect = (material) => {
    if (selectedMaterial === material) {
      setSelectedMaterial(null);
    } else {
      setSelectedMaterial(material);
    }
  };

  const GetActivePaymentTypes = () => {
    axios
      .get(`/GetActivePaymentTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setActivePaymentTypeData(response.data);
        }
      })
      .catch(error => { });
  };

  const handleChangePaymentType = event => {
    // let job = SonlandirData[0];
    // job = {
    //   ...job,
    //   PaymentTypeId: event.target.value
    // };
    // setTask(job);
    setPaymentType(event.target.value);
  };

  const handleChangePaymentDetail = event => {
    // let job = SonlandirData[0];
    // job = {
    //   ...job,
    //   PaymentDetail: event.target.value
    // };
    // setTask(job);
    setPaymentDetail(event.target.value);
  };

  const handleSave = () => {
    setSaving(true);

    setWorkCaseAndContract()
      .then(response => {
        setTimeout(() => {
          setSaving(false);
          setSaved(true);
          setTimeout(() => {
            setSaved(false);
            setActiveStep(0);
            setSelectedMaterial([]);
            setPaymentType('');
            handleCloseDialog();
            history.push(`/WorkOrder/${response.WorkOrderId}/summary`);
          }, 5000); // Show the checkmark for 3 seconds
        }, 2000); // Simulate a save operation with a timeout
      })
      .catch(error => {
        setSaving(false);
        // handle error
      });
  };

  return (
    <Container>
      {saved ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CheckCircleOutlineIcon style={{ fontSize: 100, color: 'green' }} />
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="flex-start" height="100vh" mt={4}>
          <Box className={classes.box} width="600px" border={1} borderColor="grey.500" p={3} borderRadius={4} mt={4}>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map((label, index) => (
                <Step key={label} completed={activeStep > index} className={activeStep === index ? classes.activeStep : ''} classes={{ completed: classes.completed }}>
                  <StepLabel classes={{ root: classes.step }}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className={classes.line}></div>
            {activeStep === 0 && (
              <Box className={classes.paper} mb={2} p={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Box border={1} p={2} borderRadius={4}>
                      <Typography variant="h6" gutterBottom>
                        <PersonIcon style={{ marginRight: '8px', color: '#4caf50' }} /> {/* Person icon */}
                        {t('lblCustomerInformation')}
                      </Typography>
                      <TextField name="firstName" label="Name" value={formData ? formData.ConsumerName : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="address" label="Address" value={formData ? formData.Address : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="phone" label="Telephone" value={formData ? formData.Phone : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="title" label="Region" value={formData ? formData.Region : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="lastName" label="City" value={formData ? formData.City : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="title" label="District" value={formData ? formData.District : ''} InputProps={{ readOnly: true }} fullWidth />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box border={1} p={2} borderRadius={4}>
                      <Typography variant="h6" gutterBottom>
                        <LocalMallIcon style={{ marginRight: '8px', color: '#2196f3' }} /> {/* Ürün icon */}
                        {t('lblProductInformation')}
                      </Typography>
                      <TextField name="productionPeriod" label="Brand" value={formData ? formData.Brand : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="barcode" label="Code" value={formData ? formData.ProductCode : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="modelCode" label="Product" value={formData ? formData.Product : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="productionYear" label="Production Year" value={formData ? formData.ProductionYear : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="productionMonth" label="Production Month" value={formData ? formData.ProductionMonth : ''} InputProps={{ readOnly: true }} fullWidth />
                      <TextField name="serialNumber" label="Serial Nr" value={formData ? formData.SerialNr : ''} InputProps={{ readOnly: true }} fullWidth />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            )}
            {activeStep === 1 && (
              <Box className={classes.paper} mb={2} p={2}>
                <Typography variant="h6" className={classes.header}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell> {/* Add an empty cell for the checkbox */}
                        <TableCell>{t('lblMaterial')}</TableCell>
                        <TableCell>{t('lblPrice')}</TableCell>
                        <TableCell>{t('lblVatRate')}</TableCell>
                        <TableCell>{t('lblPriceWithVat')}</TableCell>
                        <TableCell>{t('lblBenefit')}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {materials.map((material) => (
                        <TableRow
                          key={material.Materialcode}
                          selected={selectedMaterial === material}
                          onClick={() => handleMaterialSelect(material)}
                          className={selectedMaterial === material ? 'selected' : ''}
                        >
                          <TableCell>
                            <GreenCheckbox
                              checked={selectedMaterial === material}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMaterialSelect(material);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <span style={{ fontWeight: 'bold' }}>{material.Materialcode}</span> {material.MaterialDescription}
                          </TableCell>
                          <TableCell>
                            <b>
                              <Chip
                                size="small"
                                label={`${moneyFormat(material.Price, SessionUser.TenantCode, material.Currency)} ${
                                  material.Currency
                                }`}
                              />
                            </b>
                          </TableCell>
                          <TableCell>{material.VatRate}</TableCell>
                          <TableCell>
                            <b>
                              <Chip
                                size="small"
                                label={`${moneyFormat(material.PriceWithVat, SessionUser.TenantCode, material.Currency)} ${
                                  material.Currency
                                }`}
                              />
                            </b>
                          </TableCell>
                          <TableCell>{material.Benefit}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Typography>
              </Box>
            )}
            {activeStep === 2 && (
              <Box className={classes.paper} mb={2} p={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth>  
                      <TextField
                        size="small"
                        select
                        label={t('Payment Type')}
                        onChange={handleChangePaymentType}
                        value={paymentType}
                        variant="outlined"
                        fullWidth
                      >
                        {activePaymentTypeData &&
                          activePaymentTypeData.map((p) => (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t('Payment Detail')}
                      name="PaymentDetail"
                      multiline
                      size="small"
                      fullWidth
                      value={PaymentDetail}
                      onChange={handleChangePaymentDetail}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Box display="flex" alignItems="center" mt={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={attachements.name ? attachements.name : 'Upload the relevant receipt...'}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  <Button
                    variant="contained"
                    component="label"
                    style={{ backgroundColor: '#388e3c', color: 'white', marginLeft: '8px' }} // Dark green button
                  >
                    {t('lblUpload')}
                    <input
                      type="file"
                      hidden
                      onChange={(e) => handleChangeImage(e)}
                    />
                  </Button>
                </Box>
              </Box>
            )}
            {activeStep === 3 && (
              <Box className={classes.paper} mb={2} p={2}>
                <Grid container spacing={3} justifyContent="center">
                  <Grid item xs={12} md={6}>
                    <Box border={1} p={2} borderRadius={4}>
                      <Typography variant="h6" gutterBottom align="center">{t('lblPurchaseTitle')}</Typography>
                      <TextField
                        label="Name"
                        value={formData?.ConsumerName}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Address"
                        value={formData?.Address}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Brand"
                        value={formData?.Brand}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="SKU"
                        value={formData?.ProductCode}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Product"
                        value={formData?.Product}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Selected Material"
                        value={selectedMaterial?.MaterialDescription}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        margin="normal"
                      />
                      <TextField
                        label="Material Price"
                        InputProps={{
                          readOnly: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Box display="flex" alignItems="center">
                                {selectedMaterial?.Price}
                                <Box ml={1}>
                                  {selectedMaterial?.Currency}
                                </Box>
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                        margin="normal"
                      />
                    </Box>
                  </Grid>
                </Grid>
                <Box mt={4} display="flex" justifyContent="center">
                  <Card variant="outlined" style={{ padding: '16px', backgroundColor: '#f9f9f9', borderColor: '#4caf50' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isConfirmed}
                          onChange={(e) => setIsConfirmed(e.target.checked)}
                          color="primary"
                        />
                      }
                      label={
                        <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                            {t('lblPurchaseConfirm')}
                        </Typography>
                      }
                    />
                  </Card>
                </Box>
                {SessionUser.TenantId === 82 && (
                  <Box mt={2} display="flex" justifyContent="center">
                    <Typography variant="body2" align="center">
                      By proceeding, you agree to the 
                      <Link
                        href="https://www.hitachi-homeappliances.com.hk/en/customer_service/warranty_service/terms_and_conditions_of_maintenance_scheme/index.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginLeft: 4 }}
                      >
                        Terms and Conditions
                      </Link>
                    </Typography>
                  </Box>
                )}
              </Box>            
            )}
            <Grid container justifyContent="center" style={{ marginTop: '16px' }}>
              {activeStep !== 0 && (
                <Grid item xs={6} style={{ textAlign: 'left' }}>
                  <Button variant="contained" onClick={handleBack} startIcon={<ArrowBackIcon />}>
                    {t('lblBack')}
                  </Button>
                </Grid>
              )}
              <Grid item xs={6} style={{ textAlign: 'right' }}>
                {activeStep !== steps.length - 1 ? (
                  <Button variant="contained" color="primary" onClick={handleNext} endIcon={<ArrowForwardIcon />}>
                    {t('lblNext')}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={!isConfirmed || saving}
                    startIcon={saving && <CircularProgress size={20} />}
                  >
                    {t('lblSave')}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default Purchase;
